module.exports = __webpack_public_path__ + "static/media/napp.75806bf2.png";


//////////////////
// WEBPACK FOOTER
// ./src/NDF/Intro/img/napp.png
// module id = 111
// module chunks = 0